import axios from "axios";
import { SET_NOTIFICACIONES, SET_LOADING, SET_NOTIFICACIONES_ADMIN } from "../../constans/action-types";
import {
  URL,
  getAuthorizationHeader,
  getEstadoURL,
  getEstadoReciboURL,
} from "../../constans/constants";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const defaultPage = 0;
const defaultSize = 5;
export const setNotificaciones = (payload) => ({ type: SET_NOTIFICACIONES, payload });
export const setLoading = (payload) => ({ type: SET_LOADING, payload });
export const setNotificacionesAdmin = (payload) => ({ type: SET_NOTIFICACIONES_ADMIN, payload });

export const getNotificacionesPorUsuario = (
  page = defaultPage,
  size = defaultSize,
  search,
  leido
) => {
  return (dispatch) => {
    const empresaId = cookies.get("empresa");

    let urlRequest = `${URL}notificaciones/bandeja/listar?page=${page}&size=${size}&idEmpresa=${empresaId}`;

    if (search != null && search !== "") {
      urlRequest += `&search=${encodeURIComponent(search)}`;
    }
    if (leido != null && leido !== "") {
      urlRequest += `&leido=${encodeURIComponent(leido)}`;
    }

    return axios
      .get(urlRequest, getAuthorizationHeader())
      .then((res) => {
        dispatch(
          setNotificaciones({
            page: res.data.page.pageable.pageNumber,
            totalCount: res.data.page.totalElements,
            notificaciones: res.data.page.content,
          })
        );
      });
  };
};

export const getNotificacion = async (idNotificacion) => {
  try {
    const response = await axios.get(
      `${URL}notificaciones/get/${idNotificacion}`,
      getAuthorizationHeader()
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener notificación:", error);
    throw error;
  }
};

export const marcarNotificacionLeida = async (idNotificacion, username) => {
  const body = {
    username: username
  };

  try {
    const response = await axios.post(
      `${URL}notificaciones/${idNotificacion}/leido`,
      body,
      getAuthorizationHeader()
    );
    return response.data;
  } catch (error) {
    console.error("Error al marcar notificación como leída:", error);
    throw error;
  }
};

export const borrarNotificacion = async (idNotificacion) => {
  try {
    const response = await axios.delete(
      `${URL}notificaciones/borrar/${idNotificacion}`,
      getAuthorizationHeader()
    );
    return response.data;
  } catch (error) {
    console.error("Error al borrar la notificación:", error);
    throw error;
  }
};


export const getNotificacionesAdmin = (
  page = defaultPage,
  size = defaultSize,
  search,
  codEstado
) => {
  return (dispatch) => {
    const empresaId = cookies.get("empresa");

    let urlRequest = `${URL}notificaciones/bandeja/admin/listar?page=${page}&size=${size}&idEmpresa=${empresaId}`;

    if (search != null && search !== "") {
      urlRequest += `&search=${encodeURIComponent(search)}`;
    }
    if (codEstado != null && codEstado !== "") {
      urlRequest += `&codEstado=${encodeURIComponent(codEstado)}`;
    }

    return axios
      .get(urlRequest, getAuthorizationHeader())
      .then((res) => {
        dispatch(
          setNotificacionesAdmin({
            page: res.data.page.pageable.pageNumber,
            totalCount: res.data.page.totalElements,
            notificacionesAdmin: res.data.page.content,
          })
        );
      });
  };
};